import React from 'react';
import { TOKENS } from '../styles';
import type { ResourceLinkItem } from '../types';

interface Props {
  items: ResourceLinkItem[];
}

export default function ResourceLinkList({ items }: Props) {
  return (
    <div style={{ marginTop: 6 }}>
      {items.map((item, i) => (
        <a
          key={i}
          onClick={item.onClick}
          style={{
            display: 'block',
            marginBottom: 18,
            cursor: item.onClick ? 'pointer' : 'default',
            textDecoration: 'none',
          }}
        >
          <span style={{
            color: TOKENS.tealInk,
            fontWeight: 700,
            fontSize: 15,
            display: 'block',
          }}>
            {item.title}
          </span>
          <span style={{
            color: TOKENS.dark,
            fontSize: 13,
            marginTop: 2,
            display: 'block',
            fontWeight: 600,
          }}>
            {item.desc}
          </span>
        </a>
      ))}
    </div>
  );
}